





















import { Component, Vue, Prop } from 'vue-property-decorator';
import ChangeRadio from '@/components/changeRadio/changeRadio.vue';
import ProcessAdvanced from '@/views/professionalWork/workflow/advancedSetting/unit/processAdvanced.vue';
import DataTitle from '@/views/professionalWork/workflow/advancedSetting/unit/dataTitle.vue';
import AuthorizationManagement from '@/views/professionalWork/workflow/advancedSetting/unit/authorizationManagement.vue';
import { processServe } from '@/api/installServer';

@Component({
  components: {
    ChangeRadio,
    ProcessAdvanced,
    DataTitle,
    AuthorizationManagement,
  },
})
export default class AdvancedIndex extends Vue {
  @Prop() unitData: any;
  showType = 1;
  private workType: any = [
    {
      name: '流程高级设置',
      type: 1,
    },
    {
      name: '数据标题',
      type: 2,
    },
    {
      name: '权限管理',
      type: 3,
    },
  ];
  private formData: any = {
    authManage: {},
    baseConfig: {
      approverDistinct: false,
      sponsorApproveAutoPass: false,
      approverAllowAddSign: false,
      approvePromptText: '',
      approveOpinionRequired: false,
      approveAgreeMustSign: false,
    },
    caution: {
      orgMemberCode: '',
      time: '',
      weeks: [''],
    },
    dataTitle: {},
  };
  private async getCheck(data: any) {
    this.showType = data;
  }
  private back() {
    this.$emit('back');
  }
  /**
   * @desc 获取各表单的数据
   * @param1 data 表单数据
   * @returns 无
   */
  private setFormData(data: any) {
    if (data.type === 'base') {
      this.formData.baseConfig = data.baseConfig;
    }
    if (data.type === 'data') {
      this.formData.dataTitle = data.dataTitle;
    }
    if (data.type === 'auth') {
      this.formData.authManage = data.authManage;
    }
  }
  /**
   * @desc 点击发布提交各表单的数据
   */
  releaseBtn() {
    const flowFormId = this.unitData.id;
    processServe
      .getFlowConfig(flowFormId, this.formData)
      .then((res: any) => {
        console.log(res);
        // this.$message.success('发布成功');
        // this.$emit('back');
      })
      .catch((e: any) => {
        console.log(e);
        // this.$message.error('发布失败，请稍后重试');
      });
  }
  /**
   * @desc 获取单条表单数据
   * @param1 无
   * @returns 无
   */
  getFormData() {
    const flowFormId = this.unitData.id;
    processServe
      .getOneFlowConfig(flowFormId)
      .then((res: any) => {
        this.formData = res.data;
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
  mounted() {
    this.getFormData();
  }
}
